// import React from 'react'

const linkStyle = {
  background: 'transparent',
  border: '1px solid rgba(255,255,255,0.15)',
  color: '#fff',
  borderRadius: 6,
  margin: '0 2px',
  fontSize: 12,
  fontWeight: 500,
  minWidth: 32,
  textAlign: 'center'
}

const activeLinkStyle = {
  ...linkStyle,
  background: 'rgba(255,255,255,0.15)',
  border: '1px solid rgba(255,255,255,0.4)',
  color: '#fff',
  fontWeight: 700
}

const disabledLinkStyle = {
  ...linkStyle,
  color: 'rgba(255,255,255,0.25)',
  border: '1px solid rgba(255,255,255,0.06)',
  cursor: 'default'
}

export function DatalogPagination ({
  currentPage,
  totalPage,
  totalRecords,
  pageSize,
  loading,
  onPageChange
}) {
  const handleClick = (page) => {
    if (page < 1 || page > totalPage || loading) return
    onPageChange(page)
  }

  const pages = []
  const start = Math.max(1, currentPage - 2)
  const end = Math.min(totalPage, currentPage + 2)
  for (let i = start; i <= end; i++) pages.push(i)

  const pageStart = (currentPage - 1) * pageSize + 1
  const pageEnd = Math.min(currentPage * pageSize, totalRecords)

  return (
    <div className="dl-pagination">
      <span className="dl-page-info" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
        {totalRecords === 0
          ? 'No results'
          : `${pageStart}–${pageEnd} of ${totalRecords.toLocaleString()}`}
      </span>

      <nav aria-label="Log pagination">
        <ul className="pagination pagination-sm mb-0" style={{ gap: 2 }}>

          {/* Prev */}
          <li className={`page-item${currentPage <= 1 ? ' disabled' : ''}`}>
            <button
              className="page-link"
              style={currentPage <= 1 ? disabledLinkStyle : linkStyle}
              onClick={() => handleClick(currentPage - 1)}
              aria-label="Previous"
            >
              <i className="fa fa-chevron-left" />
            </button>
          </li>

          {/* First + ellipsis */}
          {start > 1 && (
            <>
              <li className="page-item">
                <button className="page-link" style={linkStyle} onClick={() => handleClick(1)}>1</button>
              </li>
              {start > 2 && (
                <li className="page-item disabled">
                  <span className="page-link" style={disabledLinkStyle}>…</span>
                </li>
              )}
            </>
          )}

          {/* Page numbers */}
          {pages.map((p) => (
            <li key={p} className={`page-item${p === currentPage ? ' active' : ''}`}>
              <button
                className="page-link"
                style={p === currentPage ? activeLinkStyle : linkStyle}
                onClick={() => handleClick(p)}
              >
                {p}
              </button>
            </li>
          ))}

          {/* Ellipsis + last */}
          {end < totalPage && (
            <>
              {end < totalPage - 1 && (
                <li className="page-item disabled">
                  <span className="page-link" style={disabledLinkStyle}>…</span>
                </li>
              )}
              <li className="page-item">
                <button className="page-link" style={linkStyle} onClick={() => handleClick(totalPage)}>
                  {totalPage}
                </button>
              </li>
            </>
          )}

          {/* Next */}
          <li className={`page-item${currentPage >= totalPage ? ' disabled' : ''}`}>
            <button
              className="page-link"
              style={currentPage >= totalPage ? disabledLinkStyle : linkStyle}
              onClick={() => handleClick(currentPage + 1)}
              aria-label="Next"
            >
              <i className="fa fa-chevron-right" />
            </button>
          </li>

        </ul>
      </nav>
    </div>
  )
}

export default DatalogPagination
